import http from '../http'

export function getMerchantList(params) {
  let url = '/user/supplierInstitutionList'
  return http.post(url,params)
}




// WEBPACK FOOTER //
// ./src/api/merchant/merchantList.js